export default "__VITE_ASSET__DIbom90Z__"